import React from 'react';
import { useTranslation } from 'react-i18next';
import ExplicitLyricsCheckboxFormGroup from './ExplicitLyricsCheckboxFormGroup';
import { FormGroupProps } from './types';
import ReadOnlyField from '../../../common/ReadOnlyField/ReadOnlyField';

type Props = FormGroupProps & {
  handleManufacturing: (field: string, value: any) => void;
};

export default function ExplicitLyricsFormGroup({
  album,
  disabled,
  readonly,
  handleManufacturing,
}: Props) {
  const { t } = useTranslation();

  return (
    <>
      {!readonly ? (
        <div className="form-group">
          <label className="col-sm-3 form-label">
            {t('product.editProduct.explicitLyrics')}
          </label>
          <div className="col-sm-6">
            <ExplicitLyricsCheckboxFormGroup
              value={album.albumMetaData?.manufacturing?.explicitLyrics}
              onChange={(value) => handleManufacturing('explicitLyrics', value)}
              disabled={disabled}
            />
          </div>
        </div>
      ) : (
        <ReadOnlyField
          id={'explicitLyrics'}
          labelTitle={t('product.editProduct.explicitLyrics')}
          value={album.albumMetaData?.manufacturing?.explicitLyrics}
        ></ReadOnlyField>
      )}
    </>
  );
}
